import React from "react";
import { Link } from "react-router-dom";

const ProductCard = ({ item }) => {
  console.log("eesu", item);
  return (
    <div className="cover">
      <Link to="/productdetail">
        <img src={item?.image?.path} alt="" />
      </Link>
      <Link to="/productdetail">
        <div className="Offerdetail">
          <h3>{item?.name}</h3>
          <span>Rs.{item?.price}</span>
        </div>
      </Link>
    </div>
  );
};

export default ProductCard;
